<template>
  <div class="VvCompletion">
    <div class="Completion" :style="completionStyle" />
  </div>
</template>

<script>
export default {
  name: 'VvCompletion',
  props: {
    percentage: {
      type: Number,
      default: 0
    }
  },
  computed: {
    completionStyle() {
      return { right: `${100 - this.percentage}%` }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.VvCompletion {
  position: relative;
  height: 8px;
  border-radius: 20px;
  width: 100%;
  background-color: white;
  overflow: hidden;

  .Completion {
    position: absolute;
    background-color: $primary;
    top: 0;
    left: 0;
    bottom: 0;
    border-radius: 20px;
  }
}
</style>
